import { cn } from '@/lib/utils';
import {
	Select,
	SelectContent,
	SelectItem,
	SelectTrigger,
	SelectValue,
} from '../ui/select';

type DropdownWidth = 'default' | 'sm' | 'lg';

type DropdownitemProps = {
	value: string;
};

export interface DropdownProps {
	placeholder: string;
	options: DropdownitemProps[];
	width?: DropdownWidth;
}

const Dropdown = ({ placeholder, options, width }: DropdownProps) => {
	return (
		<Select>
			<SelectTrigger
				className={cn(
					'wlcb-w-[180px] wlcb-text-select focus:wlcb-text-text-primary',
					{
						'wlcb-w-[240px]': width === 'lg',
						'wlcb-w-[120px]': width === 'sm',
					}
				)}
			>
				<SelectValue
					className='wlcb-block wlcb-lowercase first-letter:wlcb-capitalize'
					placeholder={placeholder}
				/>
			</SelectTrigger>
			<SelectContent>
				{options.map((selectItem, index) => {
					return (
						<SelectItem
							key={index}
							className='wlcb-block wlcb-lowercase first-letter:wlcb-capitalize'
							value={selectItem.value.toLowerCase()}
						>
							{selectItem.value}
						</SelectItem>
					);
				})}
			</SelectContent>
		</Select>
	);
};

export default Dropdown;
